import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'aos/dist/aos.css'; // AOS styles
import AOS from 'aos'; // AOS library

console.log('index.js is running'); // Debug log

AOS.init({ duration: 1000 }); // Initialize AOS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);